import { useEffect, useRef } from 'react';

// Use this hook in order to stop unmounted component updates
// use this on after async operations, and before updating state
// e.g. if(!mounted.current) return
const useIsMounted = () => {
  const mounted = useRef(true);

  useEffect(() => {
    return () => (mounted.current = false);
  }, []);

  return mounted;
};

export default useIsMounted;
